<template>
    <div class="dashboard">
                <div class="theme-card main-card">
                    <div class="box">
                        <div class="enter-intro">{{ pagecontent.enterpriseHome.heading }}</div>
                        <div class="enter-body" v-html="pagecontent.enterpriseHome.info"></div>
                    </div>
                    <div class="box">
                        <NavLogoEnterprise class="box-logo"/>
                    </div>
                </div>

                <div class="theme-card small-card">
                    <PenIcon class="small-card-icon"/>
                    <div class="small-card-description">
                        {{ pagecontent.enterpriseHome.postVacancies }}
                    </div>
                </div>
                  <div class="theme-card small-card">
                    <UsersIcon class="small-card-icon"/>
                    <div class="small-card-description">
                         {{ pagecontent.enterpriseHome.recieveApplications }}
                    </div>
                </div>
                  <div class="theme-card small-card">
                    <CheckCircleIcon class="small-card-icon"/>
                    <div class="small-card-description">
                        {{ pagecontent.enterpriseHome.traceRecruitment }}
                    </div>
                </div>
    </div>
</template>
<script>
import pagecontent from '@/assets/text.json'
import NavLogoEnterprise from '@/components/IconComponents/NavLogoEnterprise.vue';
import UsersIcon from '@/components/IconComponents/UsersIcon.vue';
import CheckCircleIcon from '@/components/IconComponents/CheckCircleIcon.vue';
import PenIcon from '@/components/IconComponents/PenIcon.vue';
export default {
    components:{
        NavLogoEnterprise,
        UsersIcon,
        CheckCircleIcon,
        PenIcon
    },
    data(){
        return{
            pagecontent
        }
    }
}
</script>
<style scoped>
    .dashboard{
        margin:0.4rem;
        display:grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-auto-rows: auto;
    }

    .enter-intro{
        font-family: var(--job-title-font);
    }
    
    .enter-body{
        font-size:1rem;
          font-family: var(--body-font);
    }
    
    .enter-body > p:last-child(){
        display:none;
    }
    
    .enter-intro{
        color:var(--intro);
        margin-bottom:1.2rem;
        font-size:3.2rem;
        line-height:2.6rem;
       
    }

    .theme-card{
        min-height:23rem!important;
        border-radius:25px;
        padding:2rem;
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 2rem;
        background: url('../../assets/images/blurs.png') no-repeat right/70%, var(--intro-background);
    }

    .main-card{
            grid-column: 1/4;
    }

    .small-card{
        background:var(--intro-background)!important;
        min-height:10rem!important;
        grid-template-columns: auto 1fr!important;
    }

    .small-card-icon{
        height:1.6rem;
        color:var(--page-header);
    }

    .small-card-description{
        margin-top:-0.2rem;
        font-family: var(--body-font);
    }

    .applicants{
        grid-column:1/2;
    }

    .shortlists{
        grid-column:2/3;
    }

    .box:last-child{
        display: grid;
    }

    .box-logo{
        justify-self: right;
        align-self: self-end;
        height:3rem;
        width:10rem;
    }
</style>